<template lang="pug">
v-col(class="tw-bg-white tw-rounded-md px-4 fill-height d-flex flex-column min-h-0 flex-grow-1 ")
  v-row(no-gutters align="center" justify-space-between class=" flex-shrink-1 flex-grow-0")
    v-col(cols="auto")
      span(class=" tw-text-lg tw-font-bold tw-capitalize") {{ $t('Common.recentActivity') }}
    v-col(class="text-right")
      v-btn-toggle(dense v-model="toggle_exclusive")
        v-btn(
          text
          :ripple="false"
          @click="filter('day', true)"
          color="blue-grey lighten-2"
          width="auto"
        )
          span(class="tw-font-medium") {{ $t('Common.day') }}
        v-btn(
          text
          :ripple="false"
          @click="filter('week', true)"
          color="blue-grey lighten-2"
          width="auto"
        )
          span(class="tw-font-medium") {{ $t('Common.week') }}
        v-btn(
          outlined
          text
          @click="filter('month', true)"
          :ripple="false"
          color="blue-grey lighten-2"
          width="auto"
        )
          span(class="tw-font-medium") {{ $t('Common.month') }}
        v-menu(
          bottom
          left
          v-model="dateSelectMenu"
          :close-on-content-click="false"
          rounded="xl"
          nudge-bottom="40"
        )
          template(v-slot:activator="{ on, attrs }")
            v-btn(
              :ripple="false"
              depressed
              v-on="on"
              v-bind="attrs"
              color="blue-grey lighten-5"
              width="30"
            )
              v-icon(color="blue-grey darken-1") mdi-calendar
          v-date-picker(
            flat
            no-title
            dark
            locale="en"
            v-model="dateSelection"
            @change="dateSelection.length == 2 ? ((dateSelectMenu = false), filter(dateSelection, true)) : ''"
            :min="minDate"
            :max="maxDate"
            range
            elevation="0"
            class=" tw-border-none tw-rounded-sm"
          ) 
  v-row(justify="start" class="d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 ")
    v-col(class=" flex-grow-1 d-flex overflow-auto flex-column flex-shrink-0 min-h-0 ")
      div(v-if="loading" class="tw-h-full ")
        v-row(no-gutters class="tw-h-full")
          v-col(align-self="stretch" align="center" class=" tw-h-full tw-flex tw-items-center tw-justify-center")
            div(class="tw-w-full tw-relative tw-h-full tw-z-50")
              div(class="tw-absolute tw-z-10 tw-h-full tw-w-full tw-from-white tw-bg-gradient-to-t")
              div(class="tw-absolute tw-w-full tw-z-0")
                kubiqa-activity-item-timeline-event-loading(v-for="i in 10" :key="i")
      div(v-else-if="loadFailed" class="tw-h-full tw-flex tw-items-center tw-justify-center")
        kubiqa-misc-empty-state(
          :title="$t('Common.emptyStates.loadErrorTitle')"
          :description="$t('Common.emptyStates.loadErrorBody')"
          :action-label="$t('Common.emptyStates.retry')"
          icon="mdi-alert-circle-outline"
          @action="filter('week')"
        )
      v-timeline(v-if="tasks.length > 0 && !loading" dense)
        kubiqa-activity-item-timeline-event(v-for="task in tasks" :key="task.id" :task="task")
      div(v-else-if="!loading && tasks.length == 0" class="tw-h-full tw-flex tw-items-center tw-justify-center")
        kubiqa-misc-empty-state(
          :title="$t(filtered ? 'Common.emptyStates.noActivityRangeTitle' : 'Common.emptyStates.noActivityTitle')"
          :description="$t(filtered ? 'Common.emptyStates.noActivityRangeBody' : 'Common.emptyStates.noActivityBody')"
          icon="mdi-calendar-blank-outline"
        )
</template>

<script>
export default {
  data() {
    return {
      toggle_exclusive: undefined,
      dateSelectMenu: null,
      dateSelection: null,
      filtered: false,
      minDate: this.$moment().subtract(365, 'days').format('YYYY-MM-DD'),
      maxDate: this.$moment().format('YYYY-MM-DD'),
      loading: true,
      loadFailed: false,
    };
  },
  computed: {
    tasks() {
      return this.$store.getters['team/tasks'];
    },
  },
  mounted() {
    let filter = [];
    this.toggle_exclusive = 1;
    filter.push(this.$moment().subtract(7, 'days'));
    filter.push(this.$moment());
    this.filter(filter);
  },
  methods: {
    async filter(value, userSelected = false) {
      this.loading = true;
      let from = '';
      let to = '';
      if (value.length == 2) {
        from = value[0];
        to = value[1];
      } else {
        switch (value) {
          case 'day':
            from = this.$moment().format('YYYY-MM-DD 00:00:00');
            to = this.$moment();
            break;
          case 'week':
            from = this.$moment().subtract(7, 'days');
            to = this.$moment();
            break;
          case 'month':
            from = this.$moment().subtract('30', 'days');
            to = this.$moment();
            break;
        }
      }
      let filters = new URLSearchParams();
      filters.append('filter[completed_between][from]', from);
      filters.append('filter[completed_between][to]', to);
      filters.append('filter[status]', 1);
      filters.append('sort', '-completed_date');

      if (this.$router.currentRoute.name == 'opportunityDetail') {
        filters.append('filter[opportunity_id]', this.$router.currentRoute.params.id);
      }

      const result = await this.$store.dispatch('team/getTasks', filters);
      this.loading = false;
      this.loadFailed = !Array.isArray(result);
      this.filtered = userSelected;
      this.dateSelection = null;
    },
  },
};
</script>
